module.exports = __webpack_public_path__ + "static/media/valor1.12aefce6.mp4";